import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

const NOTIFICATIONS_ROOT_NODE_ID = 'notifications';
const notificationsRoot = document.getElementById(NOTIFICATIONS_ROOT_NODE_ID);

function createNotificationsRootElement(options) {
  const notificationsRootElement = document.createElement('div');

  if (options.className) {
    notificationsRootElement.setAttribute('class', options.className);
  }

  return notificationsRootElement;
}

export default function NotificationsPortal(props) {
  const { className } = props;

  const rootElemRef = useRef(null);

  useEffect(() => {
    notificationsRoot.appendChild(rootElemRef.current);

    return function removeNotificationsRootElement() {
      rootElemRef.current.remove();
    };
  }, []);

  function getRootElem() {
    if (!rootElemRef.current) {
      rootElemRef.current = createNotificationsRootElement({
        className,
      });
    }

    return rootElemRef.current;
  }

  return ReactDOM.createPortal(props.children, getRootElem());
}
